import { GUEST_FOLDERS_UID } from "@Front/Utils/preferredRealOfficeUidHelpers";

/**
 * UID bureau métier à envoyer au backend pour le JWT « Espace office » lors du passage en dossiers invités.
 */
export function resolveMenuOfficeUidForGuestApiCall(
	officeUid: string,
	options: { currentOfficeUidBeforeGuest?: string } | null | undefined,
	peekLastRealOfficeUidBeforeGuest: () => string | null,
): string | undefined {
	if (officeUid !== GUEST_FOLDERS_UID) return undefined;
	return options?.currentOfficeUidBeforeGuest ?? peekLastRealOfficeUidBeforeGuest() ?? undefined;
}
